/* eslint-disable react-hooks/exhaustive-deps */

import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import CommonLayout from "../../../../_utils/CommonLayout";
import DynamicAdditionalFields from "../../../../_utils/TransactionCommonComponents/DynamicAdditionalFields";

const ScheduleInternalTransactionStepAdditionalDetails = ({
  txnPayLoad,
  additionalData,
  setAdditionalData,
  hyperLinks,
  setHyperLinks,
  timeData,
  setTimeData,
  quantities,
  setQuantities,
  uploadedFiles,
  setUploadedFiles,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  selectedValue,
  setSelectedValue,
  selectedValueMonth,
  setSelectedValueMonth,
  previewImages,
  setPreviewImages,
  handleInputChange,
}) => {
  return (
    <div
      className="max-w-tab-width-normal w-width-full mx-auto py-padding-md px-padding-md Qlg:px-padding-base"
      style={{ scrollbarWidth: "none" }}
    >
      <CommonLayout>
        <div className="w-width-full Qsmd:max-w-[var(--create-box-width)] flex flex-col gap-gap-md">
          <DynamicAdditionalFields
            headerText={globalTextFormat(
              globalText.CATEGORY_SPECIFIC_DETAILS,
              [0, 1, 2],
            )}
            requiresCategorySelection={false}
            mergeCategory={txnPayLoad?.mergeCategory}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            timeData={timeData}
            setTimeData={setTimeData}
            quantities={quantities}
            setQuantities={setQuantities}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            onInputChanged={(name, value, dataType) =>
              handleInputChange({
                target: { name, value, data_type: dataType },
              })
            }
          />
        </div>
      </CommonLayout>
    </div>
  );
};

export default ScheduleInternalTransactionStepAdditionalDetails;
